import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import ScreenHeader from '../components/ScreenHeader';
import { localAxios } from '../api';
import { workflowStatePath } from '../utils/siteMap';

export function loader() {
  return null;
}

// Resets on a real page load (refresh, reopened tab/browser, different device)
// but persists across client-side navigation within this page load, so once the
// user has been offered the resume redirect once, clicking Home again actually
// takes them Home instead of bouncing them back into the in-progress task.
let hasAutoResumedThisPageLoad = false;

const HomePage = () => {
  const navigate = useNavigate();
  // Same SWR key ProtectedRoute already fetches, so this is deduped, not a second request.
  const { data, isLoading } = useSWR('/api/me', localAxios);
  const [resumePath, setResumePath] = useState(undefined); // undefined = not decided yet

  useEffect(() => {
    if (!data) return;
    if (!hasAutoResumedThisPageLoad) {
      hasAutoResumedThisPageLoad = true;
      setResumePath(workflowStatePath(data?.data?.workflow_state));
    } else {
      setResumePath(null);
    }
  }, [data]);

  if (isLoading || resumePath === undefined) {
    return null;
  }

  if (resumePath) {
    return <Navigate to={resumePath} />;
  }

  return (
    <div className="app-wide__container">
      <ScreenHeader message="Home" />
      <div className="app-wide__main home-page__main">
        <button className="home-page__nav-btn" onClick={() => navigate('/choose')}>
          <span className="home-page__nav-title">Visit Now</span>
          <span className="home-page__nav-sub">Select a site and acknowledge your visit</span>
        </button>
        <button className="home-page__nav-btn" onClick={() => navigate('/register-visitor')}>
          <span className="home-page__nav-title">Plan a Site Visit</span>
          <span className="home-page__nav-sub">Register visitors, guardians, minors, and inviters for a visit</span>
        </button>
        <button className="home-page__nav-btn" onClick={() => navigate('/help')}>
          <span className="home-page__nav-title">Help</span>
          <span className="home-page__nav-sub">Get help using this application</span>
        </button>
      </div>
    </div>
  );
};

export default HomePage;
